import { render, staticRenderFns } from "./untemplated.vue?vue&type=template&id=a9129c2a"
import script from "./untemplated.vue?vue&type=script&lang=js"
export * from "./untemplated.vue?vue&type=script&lang=js"
import style0 from "./untemplated.vue?vue&type=style&index=0&id=a9129c2a&prod&lang=less"
import style1 from "./untemplated.vue?vue&type=style&index=1&id=a9129c2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports